(function () {
  'use strict';

  function complete(pref) {
    return pref && (pref.pouchStyle || pref.cut) &&
      (pref.waistSize || pref.size) && pref.thongStrapStyle;
  }

  function money(cents, currency) {
    var locale = (document.documentElement.lang || 'en-US').replace('_', '-');
    var formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency || 'USD'
    }).format(Number(cents) / 100);
    return formatted + ' ' + (currency || 'USD');
  }

  function update(component) {
    var price = component.querySelector('.jmt-featured-product-break__price');
    var productNode = component.querySelector('[data-jmt-featured-product-json]');
    if (!price || !productNode) {
      component.setAttribute('data-jmt-price-ready', '');
      return;
    }

    if (!price.dataset.jmtDefaultPrice) price.dataset.jmtDefaultPrice = price.textContent;
    var pref = window.JMT_PREF && window.JMT_PREF.get && window.JMT_PREF.get();
    var variant = null;
    if (complete(pref) && window.JMT_VARIANTS && window.JMT_VARIANTS.findVariant) {
      try {
        var product = JSON.parse(productNode.textContent);
        variant = window.JMT_VARIANTS.findVariant(product, {
          pouchStyle: pref.pouchStyle || pref.cut,
          waistSize: pref.waistSize || pref.size,
          thongStrapStyle: pref.thongStrapStyle
        }, { availableOnly: false, requireAll: true });
        if (!variant) {
          component.removeAttribute('data-jmt-price-ready');
          return;
        }
        price.textContent = money(variant.price, product.currency);
      } catch (error) {
        component.removeAttribute('data-jmt-price-ready');
        return;
      }
    } else {
      price.textContent = price.dataset.jmtDefaultPrice;
    }
    component.setAttribute('data-jmt-price-ready', '');
  }

  function refresh() {
    document.querySelectorAll('jmt-featured-product-break').forEach(update);
  }

  window.addEventListener('jmt:pref:change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'complete') refresh();
  else document.addEventListener('DOMContentLoaded', refresh, { once: true });
})();
